/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMedicine = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M7 2h10v4l2 2.667V22H5V8.667L7 6V2zm2 4h6V4H9v2zM8 8 7 9.333V20h10V9.333L16 8H8zm3 5v-2h2v2h2v2h-2v2h-2v-2H9v-2h2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgMedicine as Medicine };
